import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { apiUrl } from "../config/url";
import Navbar from "./Navbar";

const TaxMaster = () => {
    const user_role = localStorage.getItem("user_role");

    const [taxMasters, setTaxMasters] = useState([]);
    const [filteredTaxMasters, setFilteredTaxMasters] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [newTaxMaster, setNewTaxMaster] = useState({
        code: "",
        name: "",
        rate: "",
    });
    const [editMode, setEditMode] = useState(false);
    const [currentTaxMaster, setCurrentTaxMaster] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchTaxMasters();
    }, []);

    useEffect(() => {
        const term = searchTerm.toLowerCase();
        setFilteredTaxMasters(
            taxMasters.filter(taxMaster => {
                const name = taxMaster.name ? taxMaster.name.toString().toLowerCase() : "";
                const code = taxMaster.code ? taxMaster.code.toString().toLowerCase() : "";
                return name.includes(term) || code.includes(term);
            })
        );
    }, [searchTerm, taxMasters]);



    const fetchTaxMasters = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("api_token");
            const response = await axios.get(`${apiUrl}/admin/getAlltaxMasters`, {
                headers: { api_token: token },
            });

            if (Array.isArray(response.data.data)) {
                setTaxMasters(response.data.data);
                setFilteredTaxMasters(response.data.data);
            } else {
                console.error("Expected an array but got:", response.data);
                toast.error("Failed to fetch records");
            }
        } catch (error) {
            console.error("Error fetching tax masters", error);
            toast.error("Failed to fetch records");
        } finally {
            setLoading(false);
        }
    };

    const createTaxMaster = async () => {
        try {
            const token = localStorage.getItem("api_token");
            await axios.post(`${apiUrl}/admin/createTaxMaster`, newTaxMaster, {
                headers: { api_token: token },
            });
            fetchTaxMasters();
            resetForm();
            setIsModalOpen(false);
            toast.success("TaxMaster created successfully");
        } catch (error) {
            console.error("Error creating tax master", error);
            toast.error("Failed to create tax master");
        }
    };

    const updateTaxMaster = async () => {
        try {
            const token = localStorage.getItem("api_token");
            await axios.post(
                `${apiUrl}/admin/updatetaxMaster`,
                { ...currentTaxMaster, ...newTaxMaster },
                {
                    headers: { api_token: token },
                }
            );
            toast.success("TaxMaster updated successfully");
            fetchTaxMasters();
            resetForm();
            setIsModalOpen(false);
        } catch (error) {
            console.error("Error updating tax master", error);
            toast.error("Failed to update tax master");
        }
    };

    const handleEdit = (taxMaster) => {
        setCurrentTaxMaster(taxMaster);
        setNewTaxMaster({
            tax_id: taxMaster.id,
            code: taxMaster.code,
            name: taxMaster.name,
            rate: taxMaster.rate,
        });
        setEditMode(true);
        setIsModalOpen(true);
    };

    const openCreateModal = () => {
        resetForm();
        setEditMode(false);
        const nextCode = taxMasters.length + 1;
        setNewTaxMaster((prev) => ({ ...prev, code: nextCode.toString() }));
        setIsModalOpen(true);
    };

    const resetForm = () => {
        setNewTaxMaster({
            code: "",
            name: "",
            rate: "",
        });
        setCurrentTaxMaster(null);
        setEditMode(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (editMode) {
            updateTaxMaster();
        } else {
            createTaxMaster();
        }
    };

    return (
        <>
            <Navbar />
            <div>
                <ToastContainer />
                <h1 className="my-6 text-3xl font-bold text-center">Tax Master Management</h1>

                {loading ? (
                    <div className="py-4 text-center">
                        <p>Loading...</p>
                    </div>
                ) : (
                    <div className="flex justify-center">
                        <table className="bg-white border border-gray-200 table-auto inline-table">
                            <thead>
                                <tr>
                                    <th colSpan={user_role === "1" ? 5 : 4} className="p-4 border-none bg-white">
                                        <div className="flex justify-between items-center">
                                            <input
                                                type="text"
                                                placeholder="Search by Name or Code"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                className="p-2 border border-gray-300 rounded w-1/2"
                                            />
                                            {user_role === "1" && (
                                                <button
                                                    onClick={openCreateModal}
                                                    className="px-4 py-2 text-white bg-blue-600 rounded"
                                                >
                                                    Create TaxMaster
                                                </button>
                                            )}
                                        </div>
                                    </th>
                                </tr>
                                <tr>
                                    <th className="px-4 py-2 border bg-gray-100 text-gray-800 font-semibold text-left">ID</th>
                                    <th className="px-4 py-2 border bg-gray-100 text-gray-800 font-semibold text-left">Code</th>
                                    <th className="px-4 py-2 border bg-gray-100 text-gray-800 font-semibold text-left">Name</th>
                                    <th className="px-4 py-2 border bg-gray-100 text-gray-800 font-semibold text-left">Rate</th>
                                    {user_role === "1" && <th className="px-4 py-2 border bg-gray-100 text-gray-800 font-semibold text-left">Actions</th>}
                                </tr>
                            </thead>
                            <tbody className="text-base">
                                {filteredTaxMasters.map((taxMaster) => (
                                    <tr key={taxMaster.tax_id} className="even:bg-gray-50">
                                        <td className="px-4 py-2 border text-gray-800">{taxMaster.id}</td>
                                        <td className="px-4 py-2 border text-gray-800">{taxMaster.code}</td>
                                        <td className="px-4 py-2 border text-gray-800">{taxMaster.name}</td>
                                        <td className="px-4 py-2 border text-gray-800">{taxMaster.rate}</td>
                                        {user_role === "1" && (
                                            <td className="px-4 py-2 border text-center">
                                                {taxMaster.name !== "GST" && (
                                                    <button
                                                        onClick={() => handleEdit(taxMaster)}
                                                        className="px-3 py-1 text-sm text-white bg-yellow-500 rounded hover:bg-yellow-600"
                                                    >
                                                        Edit
                                                    </button>
                                                )}
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>
                )}

                {isModalOpen && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                        <div className="p-6 bg-white rounded shadow-lg w-96">
                            <h2 className="mb-4 text-lg font-bold">{editMode ? "Edit TaxMaster" : "Create TaxMaster"}</h2>
                            <form onSubmit={handleSubmit}>
                                <input
                                    type="text"
                                    placeholder="Code"
                                    value={newTaxMaster.code}
                                    onChange={(e) => setNewTaxMaster({ ...newTaxMaster, code: e.target.value })}
                                    disabled
                                    className="w-full p-2 mb-2 border border-gray-300 rounded"
                                />
                                <input
                                    type="text"
                                    placeholder="Name"
                                    value={newTaxMaster.name}
                                    onChange={(e) => setNewTaxMaster({ ...newTaxMaster, name: e.target.value })}
                                    disabled
                                    className="w-full p-2 mb-2 border border-gray-300 rounded"
                                />
                                <input
                                    type="number"
                                    placeholder="Rate"
                                    value={newTaxMaster.rate}
                                    onChange={(e) => setNewTaxMaster({ ...newTaxMaster, rate: e.target.value })}
                                    required
                                    className="w-full p-2 mb-4 border border-gray-300 rounded"
                                />
                                <button
                                    type="submit"
                                    className="w-full px-4 py-2 text-white bg-green-600 rounded"
                                >
                                    {editMode ? "Update TaxMaster" : "Create TaxMaster"}
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setIsModalOpen(false)}
                                    className="w-full px-4 py-2 mt-2 text-white bg-red-600 rounded"
                                >
                                    Cancel
                                </button>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default TaxMaster;
